<div class="container">
    <div class="content">
        <div class="title-container">
            <!-- <img src="/images/TMOZ Logo - Centered - Reversed - NoHammer-NoTagline.png" alt="Travel Money OZ" /> -->
            <img src="/images/travlex_2017_new-01.png" alt="Travelex UK" />
            <!-- <div class="title-text-container">
                <span class="title-text">Flight Centre</span>
            </div> -->
        </div>
        <!-- <img class="img-style" src="../../../assets/pics/tmoz-logo.png" alt="Travel Money OZ" /> -->
        <div class="top-banner">
            <!-- <img src="../../../assets/DD-9257_Deals Page Header_desktop_1920x550.jpg" alt="Martin Garrix" /> -->
            <img src="/images/tvx-hero-1280x482.jpg" alt="Travelex UK" />
            <!-- <img src="../../../assets/pics/MIC_TMG_CBA_Currency-Pass-RTW-blog_1920x420_v1.jpg" alt="Travel Money OX" /> -->
            <!-- <div class="top-banner-curved-edge"></div> -->
        </div>
        <!-- <div class="top-banner-curved-edge-backgroud">
            <div class="top-banner-curved-edge"></div>
        </div> -->
        <div class="form-content">

            <div class="menu-grid">
                <p-selectbutton class="selectBtn" [options]="stateOptions" [(ngModel)]="tableType" optionLabel="label" optionValue="value" aria-labelledby="basic" />

                <!-- <button  class="refreshBtn" matIconButton aria-label="Example icon button with a vertical three dot icon">
                    <mat-icon>refresh</mat-icon>
                </button> -->
                <div class="refreshBtn">
                    <p-button icon="pi pi-refresh" variant="outlined" severity="secondary" (onClick)="refreshAllTablesBtn()"/>
                </div>
            </div>

            <div class="bc-panel-body-grid">
                <div class="bc-layout-grid">

                    @if(tableType == 'members'){
                        <table mat-table [dataSource]="membersDataSource" class="mat-elevation-z8">

                            <!--- Note that these columns can be defined in any order.
                                    The actual rendered columns are set as a property on the row definition" -->

                            <!-- Position Column -->
                            <!-- <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef> Reg? </th>
                                <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                            </ng-container> -->

                            <!-- Pan Column -->
                            <ng-container matColumnDef="tvxPlusId">
                                <th mat-header-cell *matHeaderCellDef> TVX+ </th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.registered ? '' : 'not-registered-cell'"> {{element.tvxPlusId}} </td>
                            </ng-container>

                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.registered ? '' : 'not-registered-cell'"> {{element.name}} </td>
                            </ng-container>

                            <!-- Weight Column -->
                            <!-- <ng-container matColumnDef="weight">
                                <th mat-header-cell *matHeaderCellDef> Weight </th>
                                <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
                            </ng-container> -->

                            <!-- Symbol Column -->
                            <ng-container matColumnDef="symbol">
                                <th mat-header-cell *matHeaderCellDef> Action </th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.registered ? '' : 'not-registered-cell'" > <button mat-icon-button (click)="deleteMember(element.tvxPlusId)"> <mat-icon>delete</mat-icon></button> </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="membersDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: membersDisplayedColumns;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="4">No data</td>
                            </tr>
                        </table>
                    }

                    @if(tableType == 'links'){
                        <table mat-table [dataSource]="linksDataSource" class="mat-elevation-z8">

                            <!--- Note that these columns can be defined in any order.
                                    The actual rendered columns are set as a property on the row definition" -->

                            <!-- Position Column -->
                            <!-- <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef> Reg? </th>
                                <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                            </ng-container> -->

                            <!-- Pan Column -->
                            <ng-container matColumnDef="pan">
                                <th mat-header-cell *matHeaderCellDef> Pan </th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.registered ? '' : 'not-registered-cell'"> {{displayPan(element.pan)}} </td>
                            </ng-container>

                            <ng-container matColumnDef="tvxPlusId">
                                <th mat-header-cell *matHeaderCellDef> TVX+ </th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.registered ? '' : 'not-registered-cell'"> {{element.tvxPlusId}} </td>
                            </ng-container>

                            <!-- Weight Column -->
                            <!-- <ng-container matColumnDef="weight">
                                <th mat-header-cell *matHeaderCellDef> Weight </th>
                                <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
                            </ng-container> -->

                            <!-- Symbol Column -->
                            <ng-container matColumnDef="symbol">
                                <th mat-header-cell *matHeaderCellDef> Action </th>
                                <td mat-cell *matCellDef="let element" [ngClass]="element.registered ? '' : 'not-registered-cell'"> <button mat-icon-button (click)="deleteLink(element.pan)"> <mat-icon>delete</mat-icon></button> </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="linksDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: linksDisplayedColumns;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="4">No data</td>
                            </tr>
                        </table>
                    }


                </div>
            </div>

        </div>
    </div>
</div>